import { Controller } from '@hotwired/stimulus';

// eslint-disable-next-line import/prefer-default-export
export const method = (controller: Controller, methodName: string) => {
  const m = (controller as never)[methodName];
  if (typeof m === 'function') {
    return m;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (...args: unknown[]) => undefined;
};
